<template>
  <div>
    <div class="around-fade"></div>
    <div class="zone-modal">
      <b-overlay
        class="declaration-overlay"
        rounded="lg"
        :show="!dataLoaded && !!declarationEditId"
        v-if="!dataLoaded && !!declarationEditId"
      />

      <CloseModalButton :on-click="closeHistoryModal"></CloseModalButton>

      <div class="header">
        <h1>Historia deklaracji</h1>
      </div>

      <div class="table-block">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Data złożenia edytowanej wersji deklaracji</th>
              <th scope="col">Edytowana wersja deklaracji</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="declaration in revisions" :key="declaration.id">
              <td>
                {{ declaration.updated_at }}<br />
                <small>
                  {{ declaration.user }}<br />
                  {{ declaration.text_id | shortened }}<br />
                  {{ declaration.fuel_types }}
                </small>
              </td>
              <td>
                <b-dropdown
                  size="lg"
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret right
                >
                  <template #button-content>
                    <b-icon-three-dots-vertical/>
                    <span class="sr-only">User</span>
                  </template>
                  <b-dropdown-item :href="`/api/declarations/pdf/${declaration.id}`" target="_blank">Pobierz PDF
                  </b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="buttons-row">
        <button type="button" class="btn btn-outline-primary" @click="closeHistoryModal()">
          Zamknij
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import DeclarationsModel from "@/models/declarations";
import DeclarationsMixin from "@/mixins/DeclarationsMixin";
import CloseModalButton from "@/components/common/CloseModalButton";

export default {
  name: "HistoryModal",
  components: { CloseModalButton },
  mixins: [DeclarationsMixin],
  data() {
    return {
      dataLoaded: false,
      declaration: null,
      revisions: []
    }
  },
  methods: {
    closeHistoryModal() {
      this.$store.commit("closeHistoryModal");
    },
  },
  computed: {
    declarationHistoryId() {
      return this.$store.state.declarationHistoryId;
    }
  },
  filters: {
    shortened (value) {
      if (!value) return ''
      if (value.length < 20)
        return value;
      return value.substr(0, 8) + '.........' + value.substr(value.length - 9, value.length - 1);
    }
  },

  mounted() {
    if (this.declarationHistoryId) {
      DeclarationsModel.getDeclarationHistoryById(this.declarationHistoryId)
        .then((res) => {
          this.declaration = res.data.declaration;
          this.revisions = res.data.history;
          this.dataLoaded = true;
        });
    }
  }
}
</script>

<style scoped>
h1, h2, h3, h4, label, p {
  color: #707070;
}

.zone-modal {
  display: grid;
  grid-template-columns: 45% 55%;
  grid-template-rows: 10% 8% 72% 10%;
}

.zone-modal {
  width: 40rem;
  height: 40rem;
  padding: 1.5rem;
}

.header {
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 1;
}

h1 {
  font-size: 1.3rem;
}

h2 {
  font-size: 1.2rem;
  font-family: "Volte Semibold", serif;
}

.table-block {
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 3;
  grid-row-end: 4;
  overflow-y: auto;
}

.buttons-row {
  grid-column-start: -2;
  grid-column-end: -1;
  grid-row-start: -2;
  grid-row-end: -1;
  display: flex;
  flex-direction: row-reverse;
}

.buttons-row .btn-primary, .buttons-row .btn-outline-primary {
  min-width: 8rem;
  margin-left: 1rem;
  height: 2rem;
}

.declaration-overlay {
  position: absolute !important;
  top: 9rem;
  left: 0;
  right: 0;
  bottom: 0;
}

@media (max-height: 770px) {
  .zone-modal {
    height: 30rem;
  }
}

.table {
  width: 100%;
}
</style>
